import { VisuallyHidden } from '@reach/visually-hidden'
import PropTypes from 'prop-types'
import { useState } from 'react'

import { translate } from '@/utils/translations'

const ZoomButton = ({ setIsShowing }) => {
  const [isHovering, setIsHovering] = useState(false)

  const handleMouseIn = () => setIsHovering(true)
  const handleMouseOut = () => setIsHovering(false)
  const onHandleShow = e => {
    setIsShowing(true)
    e.preventDefault()
  }

  return (
    <button
      className={'vst-btn--transparent'}
      onBlur={handleMouseOut}
      onClick={e => onHandleShow(e)}
      onFocus={handleMouseIn}
      onMouseOut={handleMouseOut}
      onMouseOver={handleMouseIn}
      type='button'
    >
      <VisuallyHidden>
        {translate('common.view_enlarged_cover')}
      </VisuallyHidden>
      {isHovering ? <img
        alt=''
        className='zoom-icon'
        data-testid='zoom-icon'
        src={require('./zoom-icon.png')}
      /> : null}
    </button>
  )
}

ZoomButton.propTypes = {
  setIsShowing: PropTypes.func.isRequired
}

export default ZoomButton
